// Constants.
import * as DataSourcesConstants from 'constants/DataSourcesConstants';
import * as PayProductsConstants from 'constants/PayProductsConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  sources: [],
  errorMessage: '',
  isConnecting: false,
  isConnected: false,
};

export default function datasources(state = initialState, action = {}) {
  switch (action.type) {
    case DataSourcesConstants.LOAD_DATASOURCES_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case DataSourcesConstants.LOAD_DATASOURCES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        sources: initialState.sources.concat(action.sources),
      };
    case DataSourcesConstants.LOAD_DATASOURCES_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        sources: initialState.sources,
        errorMessage: action.message,
      };

    case DataSourcesConstants.CONNECT_DATASOURCE_REQUEST:
      return {
        ...state,
        isConnecting: true,
      };
    case DataSourcesConstants.CONNECT_DATASOURCE_SUCCESS:
      return {
        ...state,
        isConnecting: false,
        isConnected: true,
      };
    case DataSourcesConstants.CONNECT_DATASOURCE_FAILURE:
      return {
        ...state,
        isConnecting: false,
        isConnected: false,
        errorMessage: action.message,
      };
    case PayProductsConstants.PAY_PRODUCT_SUCCESS:
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        sources: initialState.sources,
        errorMessage: '',
        isConnecting: false,
        isConnected: false,
      };
    default:
      return state;
  }
}
